{
  "merriHistoryEndpoint": "/sku/merri-sku-upload-history",
  "merriTemplateEndpoint": "/sku/merri-sku-upload-template",
  "merriUploadEndpoint": "/sku/upload-merri-skus",

  "vendorHistoryEndpoint": "/sku/vendor-sku-upload-history",
  "vendorTemplateEndpoint": "/sku/vendor-sku-upload-template",
  "vendorUploadEndpoint": "/sku/upload-vendor-skus",

  "modelHistoryEndpoint": "/model/model-upload-history",
  "modelTemplateEndpoint": "/model/model-upload-template",
  "modelUploadEndpoint": "/model/upload-models",
  "modelDownloadAllEndpoint": "/model/download-all-model-info",
  "modelUploadModelFilesEndpoint": "/model/upload-model-files",

  "materialHistoryEndpoint": "/material/material-upload-history",
  "materialTemplateEndpoint": "/material/material-upload-template",
  "materialUploadEndpoint": "/material/upload-materials",
  "materialDownloadAllEndpoint": "/material/download-all-material-info",
  "materialUploadMaterialFilesEndpoint": "/material/upload-material-files",

  "getGuidEndpoint": "/sku/get-guid",
  "getManyGuidsEndpoint": "/sku/get-many-guids/{count}",
  "getAllSubcategoriesEndpoint": "/sku/get-all-subcategories",
  "variantSkusDownloadEndpoint": "/sku/download-variant-skus-filtered",
  "skuImagesScriptDownloadEndpoint": "/sku/download-sku-images-script",
  "skuImageFilesUploadEndpoint": "/sku/upload-sku-image-files",
  "getValidAttributeValuesEndpoint": "/sku/get-valid-attribute-values",
  "getAttributeInfoEndpoint": "/sku/get-attribute-info",
  "getVariantSkusByAttributeValueEndpoint": "/sku/get-variant-skuids-using-attribute-value/{attributeValue}",
  "postCreateValidAttributeValueEndpoint": "/sku/create-valid-attribute-value",
  "postUpdateValidAttributeValueEndpoint": "/sku/update-valid-attribute-value",
  "getVariantSkusByTextEndpoint": "/sku/get-variantskus-by-text/{text}",
  "postDiscontinueVendorSkuEndpoint": "/sku/discontinue-vendor-sku",
  "getVariantSkuByIdEndpoint": "/sku/variant-sku/{variantSkuId}",
  "postEditSingleVariantSkuEndpoint": "/sku/edit-single-variant-sku",

  "getVendorsAllEndpoint": "/vendor/get-all-vendors",
  "vendorEndpoint": "/vendor/{vendorId?}",
  "postValidateVendorNameEndpoint": "/vendor/validate/{vendorId?}",

  "getVenuesAllEndpoint": "/venue/all",
  "getVenueEndpoint": "/venue/{venueId?}",
  "postVenueEndpoint": "/venue/{venueId?}",
  "postValidateVenueNameEndpoint": "/venue/validate/{venueId?}",
  "postVenueActiveEndpoint": "/venue/{venueId}/active",
  "getRoomEndpoint": "/venue/{venueId}/room/{roomId?}",
  "postRoomEndpoint": "/venue/{venueId}/room/{roomId?}",
  "postRoomActiveEndpoint": "/venue/{venueId}/room/{roomId}/active",

  "getVenueProvidedItemsEndpoint": "/venue/{venueId}/provided-items",
  "downloadVenueProvidedItemsEndpoint": "/venue/{venueId}/provided-items/download",
  "uploadVenueProvidedItemsEndpoint": "/venue/{venueId}/provided-items/upload",
  "postVenueProvidedItemEndpoint": "/venue/{venueId}/provided-items/{variantSkuId}",
  "getVenueEventPartnersEndpoint": "/venue/{venueId}/event-partners",
  "getVenueEventPartnerUsersEndpoint": "/venue/{venueId}/event-partners/{partnerId}/users",
  "postVenueEventPartnerUsersEndpoint": "/venue/{venueId}/event-partners/{partnerId}/users",
  "getVenueShowroomPartnersEndpoint": "/venue/{venueId}/showroom-partners",
  "getVenueShowroomPartnerUsersEndpoint": "/venue/{venueId}/showroom-partners/{partnerId}/users",
  "postVenueShowroomPartnerUsersEndpoint": "/venue/{venueId}/showroom-partners/{partnerId}/users",

  "postValidatePartnerEndpoint": "/partner/validate",

  "postDownloadMerriSkusEndpoint": "/sku/download-merri-skus",
  "postDownloadVariantSkusEndpoint": "/sku/download-variant-skus",

  "getBlobContainersEndpoint": "/sku/get-searchable-file-container-names",
  "getBlobSearchFilesEndpoint": "/sku/get-blob-files-by-prefix/{container}/{keywords}",

  "customRoomPropsEndpoint": "/custom-room/props",
  "customRoomPropsTemplateEndpoint": "/custom-room/props/template",
  "customRoomPropsUploadEndpoint": "/custom-room/props/upload",
  "customRoomPropsImagesUploadEndpoint": "/custom-room/file-upload/props-images",
  "customRoomPropsModelsUploadEndpoint": "/custom-room/file-upload/props-models",
  "customRoomTexturesEndpoint": "/custom-room/textures",
  "customRoomTexturesTemplateEndpoint": "/custom-room/textures/template",
  "customRoomTexturesUploadEndpoint": "/custom-room/textures/upload",
  "customRoomTexturesImagesUploadEndpoint": "/custom-room/file-upload/textures-images",
  "customRoomTexturesMaterialsUploadEndpoint": "/custom-room/file-upload/textures-materials"
}
